(function () {
  'use strict';

  var EXPECTED_GRID = 8;
  var EXPECTED_LIMITED = 3;

  function templatePrefix() {
    var node = document.querySelector('[id^="shopify-section-template--"]');
    if (!node) return null;
    var match = node.id.match(/^shopify-section-(template--\d+__)/);
    return match ? match[1] : null;
  }

  function replaceSectionHtml(apiKey, html) {
    if (!html) return null;
    var wrap = document.createElement('div');
    wrap.innerHTML = html.trim();
    var fresh = wrap.firstElementChild;
    if (!fresh) return null;

    var current = document.getElementById('shopify-section-' + apiKey);
    if (current) {
      current.replaceWith(fresh);
      return fresh;
    }

    if (apiKey.indexOf('s26v2_subcat') !== -1) {
      var ritual = document.getElementById('shopify-section-' + apiKey.split('__')[0] + '__s26v2_ritual');
      if (ritual) {
        ritual.insertAdjacentElement('afterend', fresh);
        return fresh;
      }
    }
    return null;
  }

  function gridProductCount() {
    var grid = document.getElementById('s26-collection-grid');
    if (!grid) return EXPECTED_GRID;
    return grid.querySelectorAll('.s26-card__title').length;
  }

  function limitedCardCount() {
    return document.querySelectorAll('.s26-limited__card-title').length;
  }

  function isS26Mobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isSummer26Page() {
    return (
      document.body.classList.contains('wudy-s26-collection') ||
      /\/collections\/summer-26\/?$/.test(window.location.pathname)
    );
  }

  function hasSubcatSection() {
    var prefix = templatePrefix();
    if (!prefix) return true;
    return !!document.getElementById('shopify-section-' + prefix + 's26v2_subcat');
  }

  function summer26NeedsHeal() {
    if (!isSummer26Page()) return false;

    var grid = document.getElementById('s26-collection-grid');
    var list = grid ? grid.querySelector('.s26-grid__list') : null;
    var cols = list && list.getAttribute('style') ? list.getAttribute('style') : '';
    var staleGridLayout = cols.indexOf('--s26-cols:4') === -1;
    var staleLimitedLayout =
      document.documentElement.innerHTML.indexOf('repeat(auto-fill, minmax(230px, 1fr))') !== -1;

    return (
      gridProductCount() < EXPECTED_GRID ||
      limitedCardCount() < EXPECTED_LIMITED ||
      staleGridLayout ||
      staleLimitedLayout ||
      !hasSubcatSection()
    );
  }

  function healStaleSummer26Cache(done) {
    if (!summer26NeedsHeal()) {
      done();
      return;
    }

    var prefix = templatePrefix();
    if (!prefix) {
      done();
      return;
    }

    var sectionKeys = [prefix + 's26v2_dynamic', prefix + 's26v2_limited'];
    if (!hasSubcatSection()) {
      sectionKeys.unshift(prefix + 's26v2_subcat');
    }

    Promise.all(
      sectionKeys.map(function (key) {
        return fetch(window.location.pathname + '?sections=' + encodeURIComponent(key), {
          credentials: 'same-origin',
        })
          .then(function (res) {
            if (!res.ok) throw new Error('section fetch failed');
            return res.json();
          })
          .then(function (payload) {
            replaceSectionHtml(key, payload[key]);
          });
      })
    )
      .catch(function () {})
      .finally(done);
  }

  healStaleSummer26Cache(function () {
    var revealEls = document.querySelectorAll('[data-s26-reveal]');
    if (typeof IntersectionObserver === 'undefined' || window.matchMedia('(prefers-reduced-motion: reduce)').matches || isS26Mobile()) {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  });
})();
